import { t } from '@ulule/localize'

function getAvatar(profile, size) {
  if (size) {
    return (
      profile &&
      profile.avatar &&
      profile.avatar.versions &&
      profile.avatar.versions[size] &&
      profile.avatar.versions[size].url
    )
  }

  return (
    profile &&
    profile.avatar &&
    profile.avatar.versions &&
    profile.avatar.versions.full &&
    profile.avatar.versions.full.url
  )
}

function getCover(profile) {
  return (
    profile && profile.cover && profile.cover.versions && profile.cover.versions.full && profile.cover.versions.full.url
  )
}

export function getLabel(profile) {
  const labels = {
    team: {
      name: t('team'),
      color: 'secondary-green-500',
    },
    official: {
      name: t('official'),
      color: 'secondary-yellow-500',
    },
    connector: {
      name: t('connector'),
      color: 'primary-red-900',
    },
    captain: {
      name: t('captain'),
      color: 'brand-indigo',
    },
    expert: {
      name: t('expert'),
      color: 'primary-blue-500',
    },
  }

  if (profile && (profile.labels === null || !profile.labels)) return null

  const profileLabels =
    profile &&
    profile.labels.find((label, index) => {
      if (labels[label]) {
        return labels[label]
      }
    })

  return labels[profileLabels]
}

export const profile = (profile) => {
  return {
    ...profile,
    getAvatar: (size) => getAvatar(profile, size),
    getLabel: getLabel(profile),
    getCover: getCover(profile),
  }
}
